import {
    addToChainAfter,
    Handler,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { chain } from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/ApplyChanges";
import { ChangeCustomerContextUpdated } from "@WhiteCap/Handlers/ExtenstionApplyChanges";

type HandlerType = Handler<HasOnSuccess & HasOnError<string>>;


export const UpdatePickUpWarehouseInCache: HandlerType = ({ getState, parameter: { onError } }) => {
    const { pickUpWarehouse } =
        getState().components.addressDrawer;

    if (pickUpWarehouse && pickUpWarehouse !== undefined && pickUpWarehouse?.id !== "") {
        localStorage.setItem("selectedShipBranch", JSON.stringify(pickUpWarehouse));
    }
};

addToChainAfter(chain, ChangeCustomerContextUpdated, UpdatePickUpWarehouseInCache);
